import "./bars.scss";
import React from "react";

const Navbar = () => {
  return (
    <>
      <p className="nocolor text-center bigtext">&zwnj;</p>
    </>
  );
};

export default Navbar;